import React from 'react';
import PropTypes from 'prop-types';
import TweenLite from 'TweenLite';
import 'ScrollToPlugin';
import { inject, observer } from 'mobx-react';

import { getAncestorByAttr, getSiblings } from '../utils';
import { PREVIEW_TYPES } from '../constants';

const INITIAL_SCALE = 1.05;

const caseTransitionBehavior = (WrappedComponent, type) => {
  class CaseTransitionBehavior extends React.Component {
    static propTypes = {
      sceneChangerStore: PropTypes.object.isRequired,
      envStore: PropTypes.object.isRequired,
      progressStore: PropTypes.object.isRequired,
    };

    state = {
      animationRunning: false,
      hover: false,
    };

    runAnimation() {
      this.setState({ animationRunning: true });

      return new Promise(resolve => {
        const animate = () => {
          if (type === PREVIEW_TYPES.case) {
            this.props.UIStore.footerFadeOut();
          }
          const parentScene = getAncestorByAttr(this.containerNode, 'data-scene');
          const rowNode = getAncestorByAttr(this.containerNode, 'data-row');
          const siblings = rowNode && getSiblings(rowNode);
          const bodyWidth = document.body.offsetWidth;
          const containerBoundingRect = this.containerNode.getBoundingClientRect();
          const offsetTop = -containerBoundingRect.top;
          const offsetLeft = containerBoundingRect.x === -1 ? 0 : -containerBoundingRect.x - 1;

          if (this.contentNode) {
            TweenLite.to(this.contentNode, 0.35, { autoAlpha: 0 }, '-=0.35');
          }

          TweenLite.to(this.imageNode, 0.6, {
            y: 0,
            scale: INITIAL_SCALE,
            overwrite: 'all',
            ease: Power1.easeOut,
          });

          TweenLite.to(this.containerNode, 0.6, {
            width: bodyWidth + 2,
            height: bodyWidth,
            left: offsetLeft,
            top: offsetTop,
            ease: Power1.easeInOut,
            onComplete: () => {
              this.props.sceneChangerStore.setShouldHandleColors();

              if (!this.containerNode) {
                return;
              }

              this.containerNode.style.position = 'fixed';
              this.containerNode.style.top = 0;
              this.containerNode.style.left = '-1px';
              TweenMax.set(parentScene.querySelectorAll('[data-hide-on-animation]'), { alpha: 0 });

              this.props.progressStore.addMediaLoadedListener(() => {
                resolve({ type: 'previewBig' });
                if (type === PREVIEW_TYPES.case) {
                  setTimeout(() => {
                    this.props.UIStore.footerFadeIn();
                  }, 2000);
                }
              });
            },
          });

          if (siblings) {
            TweenLite.to(siblings, 0.15, { alpha: 0 });
          }
        };

        if (type === PREVIEW_TYPES.case && !this.props.envStore.isUserAgentMobile()) {
          TweenLite.to(window, 0.35, {
            scrollTo: {
              y: this.containerNode,
            },
            onComplete: () => {
              animate();
            },
          });
        } else {
          animate();
        }
      });
    }

    handleMouseOver = () => {
      this.setState({ hover: true });
      TweenMax.to(this.imageNode, 12, { scale: 1 });
    };

    handleMouseLeave = () => {
      this.setState({ hover: false });
      if (!this.state.animationRunning) {
        TweenMax.to(this.imageNode, 0.35, { scale: INITIAL_SCALE });
      }
    };

    handleLinkClick = to => {
      if (this.state.animationRunning) {
        return;
      }

      this.props.sceneChangerStore.onLinkClick(to, () => this.runAnimation());
    };

    render() {
      return (
        <WrappedComponent
          onLinkClick={this.handleLinkClick}
          containerNode={node => (this.containerNode = node)}
          contentNode={node => (this.contentNode = node)}
          imageNode={node => (this.imageNode = node)}
          animationRunning={this.state.animationRunning}
          hover={this.state.hover}
          onMouseOver={this.handleMouseOver}
          onMouseLeave={this.handleMouseLeave}
          isUserAgentMobile={this.props.envStore.isUserAgentMobile}
          onComponentInViewport={isVisible => this.setState({ hover: !!isVisible })}
          type={type}
          {...this.props}
        />
      );
    }
  }

  return inject(stores => ({
    sceneChangerStore: stores.store.sceneChanger,
    envStore: stores.store.envStore,
    progressStore: stores.store.progress,
    UIStore: stores.store.UIStore,
  }))(observer(CaseTransitionBehavior));
};

export default caseTransitionBehavior;



// WEBPACK FOOTER //
// ./src/components/caseTransitionBehavior.js